import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription, catchError, finalize, throwError } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
    selector: 'app-security-question',
    templateUrl: './security-questions.component.html',
    styleUrl: './security-questions.component.scss',
    standalone: false
})
export class SecurityQuestionComponent implements OnInit {

  answer: string | undefined;
  numberOfAttempts = 0;
  isLoading = false;
  secQId: number | undefined;
  user_id: string | undefined;
  question: string | undefined;
  errorText: string | undefined;

  constructor(public dialogRef: MatDialogRef<SecurityQuestionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private util: UtilService, private dialog: MatDialog) {
  }
  ngOnInit(): void {
    this.errorText = '';
    let secQIdToQuestionMap = this.data.secQIdToQuestionMap;
    let secQIdToQuestionMapkeys = Object.keys(secQIdToQuestionMap);
    this.secQId = Number.parseInt(secQIdToQuestionMapkeys[Math.floor(Math.random() * secQIdToQuestionMapkeys.length)]);
    this.question = secQIdToQuestionMap[this.secQId];
    this.user_id = this.data.user_id;
  }


  onOk() {
    this.numberOfAttempts++;
    this.isLoading = true;
    const formData = { answer: this.answer, numberOfAttempts: this.numberOfAttempts, secQId: this.secQId, user_id: this.user_id };
    const httpParams = this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post<any>('/user/forgot-password/check-security-answer/', httpParams, options).pipe(
      finalize(() => { this.isLoading = false }),
      catchError(err => {
        return throwError(err);
      })
    ).subscribe(response => {
      if (response) {
        if (response.isCorrect == "Y") {
          this.dialog.closeAll();
          this.util.displayDialogMessage("Account Status : Temporary Password",
            "A temporary password has been sent to your email. Please login with your temporary password. If you have not received your temporary password, please check your spam folder.");
        } else if (response.isCorrect == "N") {
          this.errorText = "The answer " + this.answer + " doesn't match";
          if(response.numberOfAttempts >= 6) {
            this.dialog.closeAll();
            this.util.displayDialogMessage("Account Locked",
              "Your account has been locked. Instructions on how to reset your account have been sent to your provided email address.");
          }
        }
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
